import { safeInternalReturnPath } from './externalAttendeeProfile';

export const CHILD_ACCOUNT_SETUP_REASON = 'child-account-setup';

export function buildChildAccountSetupPath(returnPath) {
  const safeReturnPath = safeInternalReturnPath(returnPath);
  if (!safeReturnPath) return '/profile?tab=family';
  const params = new URLSearchParams({
    tab: 'family',
    reason: CHILD_ACCOUNT_SETUP_REASON,
    next: safeReturnPath,
  });
  return `/profile?${params.toString()}`;
}

export function addChildTargetToReturnPath(returnPath, childUid) {
  const safeReturnPath = safeInternalReturnPath(returnPath);
  const normalizedChildUid = typeof childUid === 'string' ? childUid.trim() : '';
  if (!safeReturnPath || !normalizedChildUid) return safeReturnPath;

  const url = new URL(safeReturnPath, 'https://member-nest.local');
  url.searchParams.set('targetUserId', normalizedChildUid);
  return `${url.pathname}${url.search}${url.hash}`;
}
